export function getImageUrls(src) {
    return {
        avif: new URL(`../assets/images/${src}.avif`, import.meta.url).href,
        webp: new URL(`../assets/images/${src}.webp`, import.meta.url).href,
        png: new URL(`../assets/images/${src}.png`, import.meta.url).href,
    };
}